<ion-icon class="icon" [name]="icon()" [color]="color()"></ion-icon>
<p class="message">{{ message }}</p>
@if (showCloseButton) {
  <ion-button class="close" (click)="close()">{{
    'message_close' | translate
  }}</ion-button>
}
